// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"f897ddf2","750":"d070f4ca"}[chunkId] + ".chunk.js";
};